import moment from 'moment'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import NumberField from '../../../components/forms/NumberField'
import Select from '../../../components/forms/Select'
import Textarea from '../../../components/forms/Textarea'
import Row from '../../../components/react/Row'
import { getYear } from '../../../utils/DateUtil'
import { getStateLabels } from '../../../utils/QualityUtils'
import { arrayOf, instanceOf } from '../../../utils/StoreUtils'
import QualityAction from '../../actions/QualityAction'
import DtoQualitometer from '../../dto/DtoQualitometer'
import DtoQualitometerState from '../../dto/states/DtoQualitometerState'
import DtoQualityState from '../../dto/states/DtoQualityState'


class QualitometerStateModal extends Component {
    constructor(props) {
        super(props)
        this.state = { startDate: moment().valueOf(), qualitometer: this.props.qualitometer.id, ...props.qualitometerState }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.popupIsOpen && nextProps.popupIsOpen) {
            $('#saveStates').on('click', () => {
                if (this.props.isNew) {
                    this.create()
                } else {
                    this.update()
                }
            })
            $('#deleteStates').on('click', () => {
                this.delete()
            })
        }
    }

    update = () => {
        this.props.update(this.state).then(() => {
            this.props.fetchQualitometerStates(this.props.qualitometer.id)
            $('.modal').modal('close')
        })
    }

    create = () => {
        this.props.create(this.state).then(() => {
            this.props.fetchQualitometerStates(this.props.qualitometer.id)
            $('.modal').modal('close')
        })
    }

    delete = () => {
        this.props.delete(this.state.qualitometer, this.state.stateId).then(() => {
            this.props.fetchQualitometerStates(this.props.qualitometer.id)
            $('.modal').modal('close')
        })
    }

    render() {
        const valueList = Object.keys(getStateLabels()).map(key => ({ code: parseInt(key), name: getStateLabels()[key].value }))
        return (
            <div>
                <Row>
                    <Select col={ 8 } options={ this.props.qualityStates } value={ this.state.stateId } disabled={ !this.props.isNew }
                        label={ i18n.state } onChange={ v => this.setState({ stateId: v }) }
                    />
                    <NumberField col={ 4 } title={ i18n.year } value={ getYear(this.state.startDate) } disabled={ !this.props.isNew }
                        onChange={ v => v && this.setState({ startDate: moment().year(v).valueOf() }) }
                    />
                </Row>
                <Row>
                    <Select col={ 3 } options={ valueList } label={ i18n.value } onChange={ v => this.setState({ value: v }) } value={ this.state.value }/>
                    <Textarea col={ 9 } title={ i18n.comment } onChange={ v => this.setState({ comment: v }) } value={ this.state.comment } />
                </Row>
            </div>
        )
    }
}

QualitometerStateModal.propTypes = {
    qualitometer: instanceOf(DtoQualitometer),
    qualitometerStates: arrayOf(DtoQualitometerState),
    qualityStates: arrayOf(DtoQualityState),
    isNew: PropTypes.bool,
    qualitometerState: instanceOf(DtoQualitometerState),
    popupIsOpen: PropTypes.bool,
    update: PropTypes.func,
    create: PropTypes.func,
    delete: PropTypes.func,
    fetchQualitometerStates: PropTypes.func,
}

const mapStateToProps = store => {
    return {
        qualitometer: store.QualityReducer.qualitometer,
        qualitometerStates: store.QualityReducer.qualitometerStates,
        qualityStates: store.QualityReducer.qualityStates,
        popupIsOpen: store.SieauReducer.popupIsOpen,
    }
}

const mapDispatchToProps = {
    update: QualityAction.updateQualitometerState,
    create: QualityAction.createQualitometerState,
    delete: QualityAction.deleteQualitometerState,
    fetchQualitometerStates: QualityAction.fetchQualitometerStates,
}

export default connect(mapStateToProps, mapDispatchToProps)(QualitometerStateModal)